import { render, staticRenderFns } from "./AllocateVendor.vue?vue&type=template&id=4f98194c&scoped=true&"
import script from "./AllocateVendor.vue?vue&type=script&lang=js&"
export * from "./AllocateVendor.vue?vue&type=script&lang=js&"
import style0 from "./AllocateVendor.vue?vue&type=style&index=0&id=4f98194c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98194c",
  null
  
)

export default component.exports